const ONE_DAY = 86_400_000;

const inOneDay = () => new Date(Date.now() + ONE_DAY);

export default inOneDay;
